import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e94d09e2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94d09e2')) {
      api.createRecord('e94d09e2', component.options)
    } else {
      api.reload('e94d09e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e94d09e2&", function () {
      api.rerender('e94d09e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dataScreening/index.vue"
export default component.exports